/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { appendScript, getIcon, noAvatar } from "../../Components/Functions";
import Layout from "../../Components/Layout";
import PopOverImage from "../../Components/PopOverImage";
import { loggedUser } from "../../Constants/menus";
import { routers } from "../../Constants/routers";
import { closePanel } from "../../Redux/Panels/RightPanel/actions";
import Api from "../../Server/Api";
import AppointmentRequests from "../doctor/secure/AppointmentRequests";
import { initDashboard } from "../doctor/secure/dbjs";
import UpcomingAppointment from "./UpcomingAppointment";

const api = new Api();


const PatientDashboard = (props) => {

	const [dashboard, setDashboard] = React.useState({})

	React.useEffect(() => {
		setTimeout(() => {
			// initDashboard({ bar: barchart, height: 150, chartType: "bar" });
		}, 1500);

		api.get({ endpoint: `/users/${loggedUser?.username}/dashboard_summary/` })
            .then((res) => { if(res) {
              setDashboard(res);
            //   initDashboard({ bar: res?.review_summary?.chart, percent: res?.review_summary?.percent })
            } })

	}, []);

	const MEDICALS = JSON.parse(props?.user?.medical_record || "{}");
	const PATIENTSTATS = props?.user?.patient_stats || {};
	const stats = [
		{
			value: PATIENTSTATS?.appointments || 0,
			label: "Appointments",
			color: "is-purple",
			icon: "clock",
			link: routers.dashboard.appointments,
		},
		{
			value: PATIENTSTATS?.doctors || 0,
			label: "Doctors",
			color: "is-info",
			icon: "users",
			link: routers.dashboard.patients,
		},
		{
			value: PATIENTSTATS?.favourites || 0,
			label: "Favourites",
			color: "is-orange",
			icon: "heart",
			link: routers.dashboard.favourites
		},
	];
	const info = [
		{ label: "Age", value: MEDICALS?.age||"-" },
		{ label: "Blood Group", value: MEDICALS?.blood_group||"-" },
		{ label: "Height (m)", value: MEDICALS?.height||"-" },
		{ label: "Weight (kG)", value: MEDICALS?.weight||"-" },
	]

	return (
		<Layout sidePanel={true} title={"Dashboard"}>
			<div className="business-dashboard lifestyle-dashboard lifestyle-dashboard-v4 company-dashboard hr-dashboard personal-dashboard dashboard personal-dashboard-v3 ecommerce-dashboard ecommerce-dashboard-v1">
				<div className="columns">
					<div className="column is-8">
						<div className="columns is-multiline is-flex-tablet-p">
							<div className="column is-12">
								<div className="block-header">
									{/*left*/}
									<div className="left">
										<div className="current-user">
											<div className="h-avatar is-medium">
												<img
													className="avatar is-squared"
													src={props?.user?.image || noAvatar()}
													alt=""
												/>
											</div>
											<h3>Welcome back, {props?.user?.first_name}.</h3>
										</div>
									</div>
									{/*Center*/}
									<div className="center">
										<h4 className="block-heading">Favourites</h4>
										<p className="block-text">
                      Easily access your favourite doctors from your
                      dashboard. 

										</p>
										<div className="candidates">
                      {(dashboard?.recentsFavourites || []).map((e) => {
						return (
							<PopOverImage
								image={e?.image}
								data={e}
								type={"customer"}
								imgClass={"is-squared"}
							/>
						)
                      })}
											
					<button onClick={e => {
                        e.preventDefault();
                        window.open(routers.pages.search(), "_blank")
                      }}>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width={24}
													height={24}
													viewBox="0 0 24 24"
													fill="none"
													stroke="currentColor"
													strokeWidth={2}
													strokeLinecap="round"
													strokeLinejoin="round"
													className="feather feather-plus"
												>
													<line x1={12} y1={5} x2={12} y2={19} />
													<line x1={5} y1={12} x2={19} y2={12} />
												</svg>
											</button>
										</div>
									</div>
									{/*Right*/}
									<div className="right">
										<h4 className="block-heading">Appointments</h4>
										<p className="block-text">
											Manage your scheduled appointment from here.
										</p>
										{/* <button
                    onClick={e => {
                      e.preventDefault();
                      window.location = routers.dashboard.messanger("")
                    }}
                    className="button h-button is-bold is-fullwidth is-dark-outlined">
											Go to messages
										</button> */}
									</div>
								</div>
							</div>
							
							<div className="column is-6">
								<div className="dashboard-card p-5 is-welcome ">
                {/* <div className="welcome-progress"
                  style={{
                    width: "max-content",
                    margin: "auto"
                  }}
                >
              <div id="welcome-gauge" className="gauge" />
              <div className="meta">
                <span>Your Progress</span>
                <span className="dark-inverted">Outstanding 🎉</span>
              </div>
            </div> */}




            <div className="updates">
  {/*Header*/}
  <div className="updates-header">
    <h3 className="dark-inverted">Details</h3>
    <a href={routers.dashboard.medicalrecord} className="action-link">Update Record</a>
  </div>
  <div className="updates-list">
    
    {/*Update*/}
    {info.map((e) => {
      return(
      <div className="update-item is-dark-bordered-12">
        <p dangerouslySetInnerHTML={{ __html: e.label }}/>
        <span className="dark-inverted">{e.value}</span>
      </div>
      )
    })}
  </div>

  {/* <div className="updates-header">
    <h3 className="dark-inverted"></h3>
    <a href={routers.dashboard.appointments} className="action-link">Update Record</a>
  </div> */}
  
</div>

								</div>
                
							</div>

              <div className="column is-6">
              <div className="dashboard-card">
              {/* <div id="interviews-chart" /> */}
            

            <div className="stats-wrapper mt-5 mb-3">
									<div className="columns is-multiline is-flex-tablet-p">
										{stats.map((e) => {
											return (
												<div
													className="column is-12"
													style={{ cursor: "pointer" }}
													onClick={() => {
														window.location = e.link;
													}}
												>
													<div className="dashboard-card">
														<div className="media-flex-center">
															<div
																className={`h-icon ${e.color} is-rounded`}
																dangerouslySetInnerHTML={{
																	__html: getIcon(e.icon),
																}}
															></div>
															<div className="flex-meta">
																<span>{e.value}</span>
																<span>{e.label}</span>
															</div>
														</div>
													</div>
												</div>
											);
										})}
									</div>
								</div>
          </div>

							</div>
						</div>
					</div>
					<div className="column is-4">
						<UpcomingAppointment  is_patient={true} />
					</div>
				</div>
				<AppointmentRequests title={"Recent Appointment"} is_patient={true} />
			</div>
		</Layout>
	);
}; 

const mapStateToProps = (state) => {
	return { user: state.user.user, dashboard: state.dashboard };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientDashboard);
